export const enum InquiryState {
  Open = 0,
  Negotiating = 1,
  Closed = 2,
  OpenContactedNegotiating = 3
}